module.exports = __webpack_public_path__ + "img/index-qysl10.bd733d1a.png";